import {
  createElementVNode as _createElementVNode,
  openBlock as _openBlock,
  createElementBlock as _createElementBlock,
} from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
      },
      [
        _createElementVNode("path", {
          d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM8.5 14.3301L14.5 10.866C15.1667 10.4811 15.1667 9.51888 14.5 9.13398L8.5 5.66987C7.83333 5.28497 7 5.7661 7 6.5359L7 13.4641C7 14.2339 7.83333 14.715 8.5 14.3301Z",
          "clip-rule": "evenodd",
          "fill-rule": "evenodd",
        }),
      ],
    )
  );
}
